import {useRef, useState} from "react";
import Modal from 'react-modal';

Modal.setAppElement('#root');

const customStyles = {
    overlay: {
        zIndex: 500,
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

export function Feedback(props){
    const [IsOpenModal, setIsOpenModal] = useState(false);
    const TextTranslate = {
        feedback: {
            ru: 'Оставьте заявку',
            en: 'Contact us'
        },
        feedbackdesc: {
            ru: 'Напишите нам и представитель компании OVERCOM свяжется с Вами в ближайшее время',
            en: 'Write to us and the OVERCOM team will contact you shortly'
        },
        name: {
            ru: 'Имя *',
            en: 'Full Name *'
        },
        phone: {
            ru: 'Номер телефона *',
            en: 'Mobile Phone *'
        },
        desc: {
            ru: 'Текст заявки *',
            en: 'How we may help you? *'
        },
        required: {
            ru: '*Отмеченное — обязательно',
            en: '*required field'
        },
        subject: {
            ru: 'Тема',
            en: 'Subject'
        },
        button: {
            ru: 'ПОДТВЕРДИТЬ',
            en: 'SEND'
        },
        closebutton: {
            ru: 'СПАСИБО',
            en: 'THANKS'
        },
        sendmodal: {
            ru: 'Ваша заявка успешно отправлена!',
            en: 'We will contact you soon'
        },
        buttonaccept: {
            ru: 'Нажимая на кнопку, вы соглашаетесь с нашей “Политикой в отношении персональных данных”. Указанные данные будут использованы только для связи с Вами.',
            en: 'By clicking on the button, you accept our "Personal Data Policy". The specified data will be used only for communications with you.'
        }
    };
    const formEl = useRef(null);
    return (
        <div className={'feedback-main'}>
            <Modal
                isOpen={IsOpenModal}
                // onAfterOpen={afterOpenModal}
                // onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <h2>{TextTranslate.sendmodal[props.Lang]}</h2>
                <div className={'ok-modal-button'} onClick={() => {setIsOpenModal(false)}}><span className={'button-ok-send-span'}>{TextTranslate.closebutton[props.Lang]}</span></div>
            </Modal>
            <h2 className={'feedback-title'}>
                {TextTranslate.feedback[props.Lang]}
            </h2>
            <p className={'feedback-subtitle'}>
                {TextTranslate.feedbackdesc[props.Lang]}
            </p>
            <form ref={formEl}>
                <div className={'form_main'}>
                    <div>
                        <input placeholder={TextTranslate.name[props.Lang]} name={'name'} className={'no-text'} type={'text'} required/>
                    </div>
                    <div>
                        <input placeholder={'E-mail *'} className={'no-text'} name={'email'} type={'email'} required/>
                    </div>
                    <div>
                        <input placeholder={TextTranslate.phone[props.Lang]} name={'phone'} className={'no-text'} type={'text'} required/>
                    </div>
                    <div>
                        {/*<input placeholder={TextTranslate.subject[props.Lang]} name={'subject'} className={'no-text'} type={'text'}/>*/}
                    </div>
                    <div>
                        <textarea placeholder={TextTranslate.desc[props.Lang]} name={'description'} className={'big-text'} required/>
                    </div>
                </div>
                <p className={'required-text'}>{TextTranslate.required[props.Lang]}</p>
                <div className={'button-feedback-send'} onClick={() => {
                    if (formEl.current.reportValidity()){
                        let object = {};
                        let formData = new FormData(formEl.current);
                        formData.forEach((value, key) => object[key] = value);
                        let json = JSON.stringify(object);
                        fetch('/send_feedback/', {
                            method: 'POST',
                            cache: 'no-cache',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: json
                        }).then((response) => {
                            formEl.current.reset();
                            setIsOpenModal(true);
                        })
                    }
                }}><span className={'button-feedback-send-span'}>{TextTranslate.button[props.Lang]}</span></div>
                <p className={'required-text'}>{TextTranslate.buttonaccept[props.Lang]}</p>
                {/*<button className={'button-feedback'}><img src={props.Lang === 'ru' ? './BUTTON.svg' : './BUTTON_EN.svg'}/></button>*/}
            </form>
        </div>
    )
}
